import axios from "axios";
import API from "../api";

export const ItemTagsModule = {
  state: {
    itemTags: [],
    isRequesting: false,
    errored: false,
    error: ""
  },
  actions: {
    getItemTags({
      commit
    }) {
      return new Promise(async (resolve, reject) => {
        console.log("getting item tags")
        commit("getItemTagsRequest");
        return axios
          .get(`${API.BASE_URL}${API.ITEM_TAGS}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("getItemTagsSuccess", response.data);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("itemTagError", error);
            reject(error);
          });
      });
    },
    createItemTag({
      commit
    }, record) {
      return new Promise(async (resolve, reject) => {
        commit("createItemTagRequest");
        return axios
          .post(`${API.BASE_URL}${API.ITEM_TAGS}`, record, API.RequestHeaders())
          .then(response => {
            if (response.status === 201) {
              commit("createItemTagSuccess", response.data.original);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("itemTagError", error);
            reject(error);
          });
      });
    },
    deleteItemTag({
      commit
    }, recordId) {
      return new Promise(async (resolve, reject) => {
        commit("deleteItemTagRequest");
        return axios
          .delete(`${API.BASE_URL}${API.ITEM_TAGS}/${recordId}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("deleteItemTagSuccess", recordId);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("itemTagError", error);
            reject(error);
          });
      });
    }
  },
  mutations: {
    getItemTagsRequest(state) {
      state.isRequesting = true;
    },
    getItemTagsSuccess(state, payload) {
      state.itemTags = payload;
      state.isRequesting = false;
    },
    createItemTagRequest(state) {
      state.isRequesting = true;
    },
    createItemTagSuccess(state, payload) {
      state.itemTags.push(payload);
      state.isRequesting = false;
    },
    itemTagError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    deleteItemTagRequest(state) {
      state.isRequesting = false;
    },
    deleteItemTagSuccess(state, recordId) {
      const deletedRecord = state.itemTags.find(
        itemTag => itemTag.id === recordId
      );
      const currentIndex = state.itemTags.indexOf(deletedRecord);
      state.itemTags.splice(currentIndex, 1);
      state.isRequesting = false;
    }
  },
  getters: {
    getItemTags(state) {
      return state.itemTags;
    }
  }
};